export const SWITCH_TYPE = 'SWITCH_TYPE';
export const SWITCH_FILIAL = 'SWITCH_FILIAL';
export const SWITCH_SPECIALITY = 'SWITCH_SPECIALITY';
export const SWITCH_DATE = 'SWITCH_DATE';
export const SWITCH_DOCTOR = 'SWITCH_DOCTOR';
export const SWITCH_INIT = 'SWITCH_INIT';
export const INIT_ATTR_PARAMS = 'INIT_ATTR_PARAMS';

export const switchTypeAction = type => (dispatch) => {
    dispatch({ type: SWITCH_TYPE, payload: type });
};

export const switchFilialAction = filial => (dispatch) => {
    dispatch({ type: SWITCH_FILIAL, payload: filial });
};

export const switchSpecialityAction = speciality => (dispatch) => {
    dispatch({ type: SWITCH_SPECIALITY, payload: speciality });
};

export const switchDateAction = date => (dispatch) => {
    dispatch({ type: SWITCH_DATE, payload: date });
};

export const switchDoctorAction = doctor => (dispatch) => {
    dispatch({ type: SWITCH_DOCTOR, payload: doctor });
};

export const switchInitAction = () => (dispatch) => {
    dispatch({ type: SWITCH_INIT });
};

export const initAttrParamsAction = params => (dispatch) => {
    dispatch({ type: INIT_ATTR_PARAMS, payload: params });
};
